export const infoData = [
  { id: "ready", name: "READY" },
  { id: "unknown", name: "UNKNOWN" },
  { id: "inprogress", name: "IN PROGRESS" },
  { id: "aborted", name: "ABORTED" },
  { id: "passed2", name: "PASSED" },
  { id: "notavailable", name: "NOT AVAILABLE" },
  { id: "failednopoe", name: "FAILED NO POE DETECTED" },
  { id: "failednopower", name: "FAILED NO POWER" },
  { id: "failedlowpower", name: "FAILED POWER TOO LOW" }
];

export const infoStdData = [
  { id: "unknown2", name: "Unknown" },
  { id: "at", name: "802.3at" },
  { id: "af", name: "802.3af" },
  { id: "bt", name: "802.3bt" }
];

export const infoClassData = [
  { id: "unknown2", name: "Unknown" },
  { id: "c0", name: "Class 0" },
  { id: "c1", name: "Class 1" },
  { id: "c2", name: "Class 2" },
  { id: "c3", name: "Class 3" },
  { id: "c4", name: "Class 4" },
  { id: "c5", name: "Class 5" },
  { id: "c6", name: "Class 6" },
  { id: "c7", name: "Class 7" },
  { id: "c8", name: "Class 8" },
  { id: "c8p", name: "Class 8+" }
];

export const wifiDevice = [
  { id: 0, name: "Internal Antenna" },
  { id: 1, name: "External Antenna" },
  { id: 2, name: "USB Adapter" }
]